import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { LocalSpinner } from 'components/globals/spinner/LocalSpinner';

export const ProtectedRoutes = () => {
	const { keycloak, loading, isAuthorized } = useAuth();

	if (loading) {
		return <LocalSpinner />;
	}

	if (!keycloak.authenticated) {
		return <Navigate to="/" />;
	}

	if (!isAuthorized) {
		return <Navigate to="/unauthorized" />;
	}

	return <Outlet />;
};
